import { useState } from 'react';
import PageHeader from '../../../components/PageHeader/PageHeader';
import ReceivedInvoicesTable from '../../../components/ElectronicBilling/ReceivedInvoicesTable';
import { Box, Tabs, Tab } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CustomTabPanel from '../../../components/Tab/CustomTabPanel';
import ConfiguredRutState from '../../../components/ElectronicBilling/ConfiguredRutState';
import useConfiguredBillingRuts from '../../../hooks/useConfiguredBillingRuts';

const ReceivedInvoice = () => {
  const { t } = useTranslation();
  const [tabValue, setTabValue] = useState(0);
  const { ruts, loading, error, reload } = useConfiguredBillingRuts();

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <div>
      {loading ? <ConfiguredRutState loading /> : error || ruts.length === 0 ? (
        <ConfiguredRutState error={error} onRetry={reload} />
      ) : (
        <>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={tabValue} onChange={handleTabChange} aria-label="billing ruts tabs">
              {ruts.map((rutData) => (
                <Tab key={rutData.rut} label={rutData.rut} />
              ))}
            </Tabs>
          </Box>

          {ruts.map((rutData, index) => (
            <CustomTabPanel key={rutData.rut} value={tabValue} index={index}>
              <PageHeader title={t('received_invoices')} subtitle={t('received_invoices_desc')} />
              <ReceivedInvoicesTable selectedRut={rutData.rut} selectedLocationId={rutData.locationId} />
            </CustomTabPanel>
          ))}
        </>
      )}
    </div>
  );
};

export default ReceivedInvoice;
